import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import type { BorderType } from '@appTypes';

/* Directiva para mostrar un skeleton de carga sobre un elemento */

export type SkeletonInputValue = boolean | '' | 'translucent' | undefined;

@Directive({
  selector: '[appSkeleton]',
  standalone: true,
})
export class Skeleton {
  // Dependencias
  private elementRef = inject(ElementRef);

  // Inputs
  $value = input.required<SkeletonInputValue>({ alias: 'appSkeleton' } );
  $border = input.required<BorderType>({ alias: 'dirBorder' });

  constructor() {
    effect(() => {
      const element = this.elementRef.nativeElement as HTMLElement;

      // Limpiar clases previas
      element.classList.remove('skeleton-container');
      element.classList.remove('skeleton-container--translucent');
      element.classList.remove('border-tiny');
      element.classList.remove('border-small');
      element.classList.remove('border-medium');
      element.classList.remove('border-large');

      const value = this.$value();

      // Aplicar border radius
      if (value !== false && this.$border() !== 'none')
        element.classList.add(`border-${ this.$border() }`);
      else if (value === false)
        return;

      // Aplicar clases del skeleton
      if (value === undefined || value === '' || value === true)
        element.classList.add('skeleton-container');
      else
        element.classList.add('skeleton-container--translucent');
    });
  }
}
